import { Component, ViewChild } from '@angular/core';

import { I18NextModule } from 'angular-i18next';

import { ButtonModule, ModalComponent, ModalModule, SmartbarModule } from '@hdms/shared/ui-core';

import { ModalCloseBase } from '../modal-base';

@Component({
  selector: 'as-ftsw-outdated-modal',
  templateUrl: './outdated-modal.component.html',
  standalone: true,
  imports: [ModalModule, SmartbarModule, ButtonModule, I18NextModule]
})
export class OutdatedModalComponent extends ModalCloseBase {
  @ViewChild('outdatedVersionOverlay') outdatedVersionOverlay: ModalComponent;

  open(): void {
    this.outdatedVersionOverlay.closeDisabled = true;
    this.outdatedVersionOverlay.open();
  }

  override dismiss(): void {
    super.dismiss();
  }

  refreshPage(): void {
    window.location.reload();
  }
}
